/**
 * https://ru.m.wikipedia.org/wiki/Файл:French_suits.svg
 */
import {random, randomItem} from '../../../utils'
import {Canvas} from '../Deck/Card/Canvas'
import {SUITS_IMAGE} from '../../../common'

const SUIT_SYMBOL_SIZE = window.innerWidth < 400 ? 35 : 50
const SHADOW_POS = window.innerWidth < 400 ? [2, 3] : [3, 5]

const drawSymbolCache: {[key: string]: HTMLCanvasElement} = {}

const drawSymbol = (
    suit: string,
    color: string = ''
): HTMLCanvasElement | void => {
    const key = suit + color

    if (!drawSymbolCache[key]) {
        let canvas = new Canvas(SUIT_SYMBOL_SIZE, SUIT_SYMBOL_SIZE)
        let ctx = canvas.ctx
        // bg
        if (
            process.env.NODE_ENV === 'development' &&
            window.location.search === '?debug-animation'
        ) {
            ctx.fillStyle = 'rgba(0,0,0,0.25)'
            ctx.fillRect(0, 0, SUIT_SYMBOL_SIZE, SUIT_SYMBOL_SIZE)
        }
        if (SUITS_IMAGE.complete) {
            let w = SUIT_SYMBOL_SIZE - 5
            let pos = [
                suit === 'S' || suit === 'D' ? 0 : 100,
                suit === 'S' || suit === 'H' ? 0 : 100,
                100,
                100,
            ]
            let shadowArgs = [SUITS_IMAGE]
                // @ts-ignore
                .concat(pos)
                .concat(SHADOW_POS[0], SHADOW_POS[1], w, w)
            ctx.globalAlpha = 0.25
            ctx.drawImage.apply(ctx, shadowArgs)
            ctx.globalAlpha = 1
            // @ts-ignore
            let args = [SUITS_IMAGE].concat(pos).concat(0, 0, w, w)
            ctx.drawImage.apply(ctx, args)
            drawSymbolCache[key] = canvas.canvas
        }
    }
    return drawSymbolCache[key]
}

export class SuitSymbol {
    private x: number
    private y: number
    private s: string

    constructor(x: number, y: number) {
        this.x = x
        this.y = y
        this.s = randomItem(['S', 'H', 'C', 'D'])
    }

    public animate(ctx: CanvasRenderingContext2D, timeout: number) {
        ctx.clearRect(this.x, this.y, SUIT_SYMBOL_SIZE, SUIT_SYMBOL_SIZE)
        this.y += Math.ceil(timeout * 0.15)

        if (this.y >= window.innerHeight) {
            this.y = random(0, window.innerHeight) * -1
            this.x = random(0, window.innerWidth - 50)
            this.s = randomItem(['S', 'H', 'C', 'D'])
        }
        this.draw(ctx)
    }

    public draw(ctx: CanvasRenderingContext2D, highlight: boolean = false) {
        if (highlight) {
            ctx.fillStyle = '#fff'
            ctx.fillRect(this.x, this.y, SUIT_SYMBOL_SIZE, SUIT_SYMBOL_SIZE)
        }
        let symbol = drawSymbol(this.s)

        if (symbol) {
            ctx.drawImage(symbol, this.x, this.y)
        }
    }

    public getPos() {
        return [this.x, this.y]
    }

    public intersection(symbol: SuitSymbol): boolean {
        if (symbol !== this) {
            let [x, y] = symbol.getPos()

            if (y > 0 && this.y > 0) {
                let x2 = Math.pow(x - this.x, 2)
                let y2 = Math.pow(y - this.y, 2)

                if (Math.sqrt(x2 + y2) < SUIT_SYMBOL_SIZE) {
                    return true
                }
            }
        }
        return false
    }
}
